import React, {Component} from "react";
import LoadingIndicator from '../../utils/LoadingIndicator';
import {Row, Col, Alert, Progress, CardTitle, Card, CardHeader,CardBody, FormGroup, Label, Form, Input, Modal, ModalHeader, ModalBody, ModalFooter, Button, ButtonDropdown, Table, Badge,  Pagination, PaginationItem, PaginationLink, DropdownMenu,DropdownToggle, ButtonGroup,Dropdown,DropdownItem} from 'reactstrap';
import {ajaxWrapperGet, ajaxWrapperPost} from "../../utils/deviceAPI";
import moment from 'moment'


class Pendingnotifications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalRemovePendingInvites: false,
            modalAcceptPendingInvites: false,
            modalNewSiteAccepted: false,
            notificationSiteName: "",
            notificationPersonName: "",
            notificationDeviceName: "",
            loading: true
        };
        this.toggleReject = this.toggleReject.bind(this);
        this.toggleAccept = this.toggleAccept.bind(this);
        this.notificationRejectAccept = this.notificationRejectAccept.bind(this);
        this.notificationAccept = this.notificationAccept.bind(this);
        this.toggleAcceptNewSite = this.toggleAcceptNewSite.bind(this);
    }
    componentDidMount() {
            this.setData();
    }
    setData() {
        ajaxWrapperGet('/api/user/pendingNotifications').then((data) => {
            this.newNotificationFeeder(data.length);
            this.setState({
                data,
                loading: false
            });

        });
    }

    selectedNotification(siteName = "", personName = "", deviceName = "") {
        this.setState({
            notificationSiteName: siteName,
            notificationPersonName: personName,
            notificationDeviceName: deviceName
        });
    }

    toggleReject() {
        this.setState({
            modalRemovePendingInvites: !this.state.modalRemovePendingInvites
        });
    }
    toggleAccept() {
        this.setState({
            modalAcceptPendingInvites: !this.state.modalAcceptPendingInvites
        });
    }
    toggleAcceptNewSite() {
        ajaxWrapperGet('/api/user/pendingNotifications').then((data) => {
            this.newNotificationFeeder(data.length);
            this.setState({
                data,
                modalNewSiteAccepted: !this.state.modalNewSiteAccepted,
                modalAcceptPendingInvites: false
            });
        });

    }
    notificationRejectAccept() {
        let postData = {
            dev: this.state.notificationDeviceName
        };
        ajaxWrapperPost(`/api/user/pendingNotificationsDelete`,postData).then((data) => {
            this.toggleReject();
            this.selectedNotification();
            this.setData();
        });
    }
    notificationAccept() {
        let postData = {
            dev: this.state.notificationDeviceName
        };
        ajaxWrapperPost(`/api/user/pendingNotificationsAccept`,postData).then((data) => {
            this.selectedNotification();
            this.props.reloadNavBar();
        });
    }
    handleLogout(){
        localStorage.removeItem('id_token');
        this.props.history.replace('/login');

    }
    newNotificationFeeder = (len) => {
        this.props.checkForNewNotifications(len);
    };

    render() {
        if (this.state.loading) {
            return <LoadingIndicator />;
        }
        if (this.state.data.length === 0) {
            return(
                <Alert color="secondary" >
                    <small>You currently don't have any pending invites. </small>
                </Alert>
            )
        }
        else {

            const listItems = this.state.data.map((site,index) => {
                    return (
                        <li key={index} className="mb-3 mt-3 listSiteItems">
                            <i className="fa fa-globe text-secondary"></i>
                            <div className="desc-n">
                                <div className="title">{site.siteName}</div>
                                <div className="small text-muted text-lowercase pb-3">sent by {site.firstname} {site.lastname} on {moment(site.invitationDateTime).format('MM/DD/YY - hh:mm:ss A')}</div>
                            </div>
                            <div className="value">
                                <Button color="success" className="text-white mr-3" onClick={() => {this.toggleAccept(); this.selectedNotification(site.siteName,`${site.firstname} ${site.lastname}`, site.deviceName)}}>Accept</Button>
                                <Button color="danger" className="text-white" onClick={() => {this.toggleReject(); this.selectedNotification(site.siteName,`${site.firstname} ${site.lastname}`, site.deviceName)}}>Reject</Button>
                                <Modal isOpen={this.state.modalRemovePendingInvites} toggle={this.toggleReject} >

                                    <ModalBody>
                                        <Row className="pb-4">
                                            <Col sm="10">
                                                <CardTitle className="mb-1">Reject Notification</CardTitle>
                                            </Col>
                                        </Row>
                                        <Row className="pb-4">
                                            <Col sm="12">
                                                <div className="small text-muted">Do you wish to reject the notification for {this.state.notificationSiteName} from {this.state.notificationPersonName} ?</div>
                                            </Col>
                                        </Row>
                                        <Row className="pb-4">
                                            <Col sm="6" className="small text-muted">
                                                <Button color="link" className="btn btn-block" onClick={this.toggleReject}>Cancel</Button>
                                            </Col>
                                            <Col sm="6" className="small text-muted">
                                                <Button color="danger" className="btn btn-block" onClick={this.notificationRejectAccept}>Remove</Button>
                                            </Col>
                                        </Row>
                                    </ModalBody>
                                </Modal>
                                <Modal isOpen={this.state.modalAcceptPendingInvites} toggle={this.toggleAccept} >

                                    <ModalBody>
                                        <Row className="pb-4">
                                            <Col sm="10">
                                                <CardTitle className="mb-1">Accept Notification</CardTitle>
                                            </Col>
                                        </Row>
                                        <Row className="pb-4">
                                            <Col sm="12">
                                                <div className="small text-muted">You will be granted access to {this.state.notificationSiteName}. This invite was sent by {this.state.notificationPersonName} ?</div>
                                            </Col>
                                        </Row>
                                        <Row className="pb-4">
                                            <Col sm="6" className="small text-muted">
                                                <Button color="link" className="btn btn-block" onClick={this.toggleAccept}>Cancel</Button>
                                            </Col>
                                            <Col sm="6" className="small text-muted">
                                                <Button color="success" className="btn btn-block" onClick={() => {this.notificationAccept(); this.toggleAcceptNewSite();}}>Accept</Button>
                                            </Col>
                                        </Row>
                                    </ModalBody>
                                </Modal>
                                <Modal isOpen={this.state.modalNewSiteAccepted} toggle={this.toggleAcceptNewSite} >

                                    <ModalBody>
                                        <Row className="pb-4">
                                            <Col sm="10">
                                                <CardTitle className="mb-1">Accepted</CardTitle>
                                            </Col>
                                        </Row>
                                        <Row className="pb-4">
                                            <Col sm="12">
                                                <div className="small text-muted">Site invitation accepted, press continue to return to the system.</div>
                                            </Col>
                                        </Row>
                                        <Row className="pb-4">
                                            <Col sm="12" className="small text-muted">
                                                <Button color="secondary" className="btn btn-block" onClick={() => {this.toggleAcceptNewSite(); this.props.reloadNavBar();}}>Continue</Button>
                                            </Col>
                                        </Row>
                                    </ModalBody>
                                </Modal>
                            </div>
                        </li>
                    );
                }
            );
            return (
                <ul className="icons-list mb-5 list-inline animated fadeIn">
                    {listItems}
                </ul>
            )
        }
    }
}

export default Pendingnotifications;



// WEBPACK FOOTER //
// ./src/components/Sitelist/Pendingnotifications.js